/* Newsletter sign-up glue for the HubSpot newsletter forms.

   The sign-up form is a HubSpot form rendered by HubSpot's developer embed
   (snippets/hubspot-form.liquid) as plain HTML: in the cta-newsletter
   section, and in the sign-up modal (snippets/newsletter-modal.liquid) opened
   by the satin nickel hero's Notify me button and small-newsletter-form's
   Sign up button. This script treats every .hubspot-form-embed on the page
   the same way:

   - loading: the embed starts empty (CSS spinner) with aria-busy, cleared
     when HubSpot injects the form;
   - prefill: an email in the URL (?email=), remembered for the rest of the
     tab, is filled into the email field once it exists;
   - submit: HubSpot's button goes busy → the form fades out with its height
     held; HubSpot swaps in the thank-you block → it fades in and the height
     eases down; a failed request undoes the fade;
   - the modal: a native <dialog>, opened by [data-newsletter-modal]. */
(function ($) {
  'use strict';

  // Guard against double-binding when multiple sections load this file
  if (window.newsletterCaptureInit) return;
  window.newsletterCaptureInit = true;

  // Same storage key the newsletter page reads, so an email from ?email=
  // follows the visitor there
  var EMAIL_KEY = 'newsletterEmail';
  var PREFILL_POLL_MS = 150;
  var PREFILL_TIMEOUT_MS = 20000;
  // Fade-out of the form and of the host's intro copy (hubspot-form.css)
  // while a submission is in flight
  var SUBMIT_FADE_MS = 300;

  var store = function (key, value) {
    try { sessionStorage.setItem(key, value); } catch (e) {}
  };
  var read = function (key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  };
  var forget = function (key) {
    try { sessionStorage.removeItem(key); } catch (e) {}
  };

  var publish = function (name, data) {
    if (typeof Shopify === 'undefined' || !Shopify.analytics) return;
    Shopify.analytics.publish(name, $.extend({
      path: window.location.pathname,
      timestamp: new Date().toISOString()
    }, data));
  };

  /* ---------- prefill ---------- */

  // HubSpot's renderer keeps its own state, so a bare .value assignment is
  // overwritten. Go through the native setter and raise the events it listens to.
  var setFieldValue = function (input, value) {
    var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    if (setter && setter.set) {
      setter.set.call(input, value);
    } else {
      input.value = value;
    }
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  var pendingEmail = null;
  var pollTimer = null;
  var pollStarted = 0;

  // Fill every rendered, still-empty email field; done once all embeds have one
  var tryPrefill = function () {
    if (!pendingEmail) return true;
    var $embeds = $('.hubspot-form-embed');
    if (!$embeds.length) return true;
    var remaining = 0;
    $embeds.each(function () {
      var input = $(this).find('input[type="email"]').get(0);
      if (!input) { remaining += 1; return; }
      if (!input.value) setFieldValue(input, pendingEmail);
    });
    if (remaining === 0) pendingEmail = null;
    return remaining === 0;
  };

  var prefill = function (email) {
    if (!email) return;
    pendingEmail = email;
    if (tryPrefill()) return;

    clearInterval(pollTimer);
    pollStarted = Date.now();
    pollTimer = setInterval(function () {
      if (tryPrefill() || Date.now() - pollStarted > PREFILL_TIMEOUT_MS) {
        clearInterval(pollTimer);
      }
    }, PREFILL_POLL_MS);
  };

  /* ---------- embed lifecycle ---------- */

  // After a successful submit HubSpot replaces the form with its thank-you
  // block (.hsfc-PostSubmit). Mark the wrapper and its host (section or
  // modal) so their subtext can fade, clear the remembered email and record
  // the sign-up. Called only by the DOM observer once the thank-you block is
  // in place, never from HubSpot's submission:success event: that fires
  // before the thank-you renders (so there is nothing to measure yet), and
  // the observer then sees the still-busy button and holds the form's full
  // height again with nothing left to release it. The event is also
  // page-wide, so it would mark every embed on the page as submitted.
  var markSubmitted = function (embed) {
    var $embed = $(embed);
    var $wrapper = $embed.closest('.hubspot-form');
    if ($wrapper.hasClass('is-submitted')) return;
    $wrapper.addClass('is-submitted');
    var $modal = $embed.closest('.newsletter-modal');
    var $host = $embed.closest('.cta-newsletter-section, .newsletter-modal');

    // Nothing changes size until the content has faded out. The fade began
    // when HubSpot's button went busy; if the thank-you has arrived sooner,
    // the collapse, narrowing and height easing (all delayed by this CSS
    // variable) wait out the rest of it.
    var started = $embed.data('submitStarted');
    var fadeLeft = started ? Math.max(0, SUBMIT_FADE_MS - (Date.now() - started)) : SUBMIT_FADE_MS;
    $host.css('--newsletter-thanks-delay', fadeLeft + 'ms');

    // The host's intro copy (marked data-newsletter-submit-collapse)
    // collapses away as its tick opens; hubspot-form.css animates both.
    // CSS can't transition from height: auto, so pin each to its current
    // height, apply that, then take it to 0 alongside is-submitted.
    var $collapse = $host.find('[data-newsletter-submit-collapse]');
    var heights = $collapse.map(function () { return this.offsetHeight; }).get();
    $collapse.each(function (i) { $(this).css('height', heights[i] + 'px'); });
    if ($collapse.length) void $host.get(0).offsetHeight;
    $collapse.css('height', 0);

    $host.addClass('is-submitted');
    forget(EMAIL_KEY);
    publish('newsletter_form_submitted', {
      formType: 'hubspot',
      source: $modal.length ? $modal.attr('data-newsletter-source') + '_modal' : 'cta_newsletter'
    });

    // HubSpot's thank-you rich text ends with an empty &nbsp; paragraph as a
    // spacer. Hide any paragraph with no visible text (trim() treats &nbsp; as
    // whitespace) so it takes no space; done before the height is measured.
    $embed.find('.hsfc-PostSubmit .hsfc-RichText > p').filter(function () {
      return !this.textContent.trim();
    }).attr('hidden', '');

    // The form has just been swapped for the (shorter) thank-you block. The
    // embed's height was held when submitting started; ease it down to the
    // new content, then let it flow naturally again.
    var target = $embed.find('.hsfc-PostSubmit').outerHeight(true) || 0;
    var released = false;
    var release = function () {
      if (released) return;
      released = true;
      $embed.off('transitionend.newsletterThanks').css('min-height', '').removeClass('is-submitting');
      $host.removeClass('is-submitting');
    };
    window.requestAnimationFrame(function () {
      $embed.css('min-height', target + 'px');
      // Only the embed's own min-height transition, not ones bubbling up from HubSpot's markup
      $embed.on('transitionend.newsletterThanks', function (e) {
        if (e.target === embed) release();
      });
      // transitionend doesn't fire when transitions are disabled (reduced motion)
      setTimeout(release, fadeLeft + 600);
    });
  };

  // Watch each embed: it starts empty (CSS shows a spinner via :empty) with
  // aria-busy, which is cleared the moment HubSpot injects the form. The same
  // observer then sees HubSpot's submit button go busy (validation passed,
  // request in flight) to start the fade-out, sees it settle again on a failed
  // request to undo it, and sees the thank-you block replace the form.
  var watchEmbed = function (embed) {
    var $embed = $(embed);
    var $host = $embed.closest('.cta-newsletter-section, .newsletter-modal');
    var check = function () {
      if (embed.childNodes.length) embed.removeAttribute('aria-busy');

      if ($embed.find('.hsfc-PostSubmit').length) {
        markSubmitted(embed);
        return;
      }

      var busy = $embed.find('.hsfc-Button[aria-busy="true"], .hsfc-Button--loading').length > 0;
      if (busy && !$embed.hasClass('is-submitting')) {
        // Hold the current height so the fade-out doesn't collapse the host;
        // the host's class fades its intro copy with the form
        $embed.css('min-height', embed.offsetHeight + 'px').addClass('is-submitting').data('submitStarted', Date.now());
        $host.addClass('is-submitting');
      } else if (!busy && $embed.hasClass('is-submitting')) {
        // Request finished without a thank-you block: HubSpot is showing an error
        $embed.css('min-height', '').removeClass('is-submitting');
        $host.removeClass('is-submitting');
      }
    };
    check();
    if (!('MutationObserver' in window)) { embed.removeAttribute('aria-busy'); return; }
    new MutationObserver(check).observe(embed, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-busy', 'class']
    });
  };

  /* ---------- modal ---------- */

  var modalOpener = null;

  var openModal = function (dialog, opener) {
    if (dialog.open) return;
    modalOpener = opener || null;
    dialog.showModal();
    $(document.body).addClass('newsletter-modal-open');
    publish('newsletter_modal_opened', { source: $(dialog).attr('data-newsletter-source') });
  };

  var closeModal = function (dialog) {
    if (dialog.open) dialog.close();
  };

  // small-newsletter-form can render more than once on a page (footer and a
  // banner), and a snippet can't make its own unique ID, so each copy's modal
  // gets one here and its button is pointed at it. The modal also moves to
  // <body> so the footer's and banners' styles can't reach into it.
  var hoistModals = function () {
    $('[data-newsletter-modal-host]').each(function (i) {
      var $host = $(this);
      var $dialog = $host.find('dialog.newsletter-modal');
      if (!$dialog.length) return;
      var id = 'NewsletterModal-' + i;
      $dialog.find('#' + $dialog.attr('id') + '-title').attr('id', id + '-title');
      $dialog.attr({ id: id, 'aria-labelledby': id + '-title' }).appendTo(document.body);
      $host.find('[data-newsletter-modal]').attr('data-newsletter-modal', id);
    });
  };

  $(function () {
    hoistModals();

    // Prefill from the URL (?email=) or an earlier sign-up attempt in this tab
    var params = new URLSearchParams(window.location.search);
    var initial = params.get('email') || (read(EMAIL_KEY) ? decodeURIComponent(read(EMAIL_KEY)) : null);
    if (initial) {
      store(EMAIL_KEY, encodeURIComponent(initial));
      prefill(initial);
    }

    $('.hubspot-form-embed').each(function () { watchEmbed(this); });

    // HubSpot's developer embed announces itself on window; use it as a nudge
    // when available, the observer and poll above cover it either way.
    window.addEventListener('hs-form-event:on-ready', function () { tryPrefill(); });

    // The button opens the modal. Without <dialog> support (or JS) the link
    // falls through: to the form in the CTA section on the hero, to the
    // newsletter page from small-newsletter-form.
    $(document).on('click', '[data-newsletter-modal]', function (e) {
      var dialog = document.getElementById($(this).attr('data-newsletter-modal'));
      if (!dialog || typeof dialog.showModal !== 'function') return;
      e.preventDefault();
      openModal(dialog, this);
    });

    $(document).on('click', '[data-newsletter-modal-close]', function () {
      closeModal($(this).closest('dialog').get(0));
    });

    // Click on the backdrop (the dialog element itself, outside its inner panel)
    $(document).on('click', 'dialog.newsletter-modal', function (e) {
      if (e.target === this) closeModal(this);
    });

    // Fires for the close button, backdrop click and Escape alike
    $('dialog.newsletter-modal').on('close', function () {
      $(document.body).removeClass('newsletter-modal-open');
      if (modalOpener && typeof modalOpener.focus === 'function') modalOpener.focus();
      modalOpener = null;
    });
  });
})(jQuery);
